import { useTranslation } from "react-i18next"
import { BaseModalWindow } from "../../../../../components/modalWindows/BaseModalWindow"
import { DateInput, TimePickerInput } from "../../../../../components/controls/inputs/BaseInput"
import { useMemo, useState } from "react"
import { DateTime } from "luxon"
import { DateStringsFormat } from "../../../../../hoc/DatePeriodPanel/DatePeriodPanel"
import { Moment } from "moment"

interface IModalCloseCashSessionProps {
    cancel: () => void
    ok: (dateTime?: DateTime | string) => void
}

export const ModalCloseCashSession : React.FC<IModalCloseCashSessionProps> = (props) => {
    const { t } = useTranslation();
    const [valueDate, setValueDate] = useState<DateTime | null | undefined>(null);
    const [valueTime, setValueTime] = useState<Moment | null | undefined>(null);
    
    const combinedDateTime = useMemo(() => {
        if (!valueDate) return null;
        
        if (!valueTime) {
            return valueDate;
        }
        
        return valueDate.set({
            hour: valueTime.hours(),
            minute: valueTime.minutes(),
            second: valueTime.seconds()
        })
        .setZone('utc').toISO()
        
    }, [valueDate, valueTime]);

    const handleOk = () => {
        props.ok(combinedDateTime || undefined);
    }

    return (
        <BaseModalWindow
            header={t('cashSession.headerModalCloseCashSession')}            
            ok={{
                onClick: () => handleOk(),
                title: "OK",
                disabled: !valueDate || !valueTime
            }}
            cancel={{ onClick: () => props.cancel(), title: "Отмена" }}
            footerStyle='customStyles'
        >
            <div style={{height: 100, display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 15}}>
                <div>{t('cashSession.titleDateCloseCashSession')}</div>
                <DateInput
                    isModal
                    onBlur={(value) => {
                        if (typeof value === "string") return;
                        (value?.toFormat(DateStringsFormat))
                        setValueDate(value)
                    }}
                />
                <TimePickerInput
                    showSecond ={false}                   
                    onChange={(value) => {
                        if (typeof value === "string") return;
                        setValueTime(value)
                    }}
                />
            </div>
        </BaseModalWindow>
    )
}